import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import {
  formatAppointmentTimeRange,
  markAppointmentReminderSent,
} from "@/core/appointments/appointment-store";
import { notifyAppointmentReminder as notifyAppointmentReminderApi } from "@/core/hospitol-api-client";
import { pushLocalNotification } from "@/core/notifications/local-notifications";
import { routes } from "@/router/all_routes";

export type AppointmentReminderResult = {
  channel: "sms" | "in_app";
  detail: string;
};

/** Rappel RDV patient — SMS si téléphone, sinon in-app (démo). */
export async function notifyAppointmentReminder(input: {
  appointmentId: string;
  patientId: string;
  patientName: string;
  patientPhone?: string;
  scheduledAt: string;
  durationMinutes: number;
  serviceUnit: string;
  practitioner: string;
  motif: string;
}): Promise<AppointmentReminderResult> {
  const dateLabel = new Date(input.scheduledAt).toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  const timeRange = formatAppointmentTimeRange(input.scheduledAt, input.durationMinutes);
  const appointmentAt = `${dateLabel} ${timeRange}`;
  const phone = input.patientPhone?.trim() ?? "";
  const channel = phone ? ("sms" as const) : ("in_app" as const);

  pushLocalNotification({
    title: channel === "sms" ? "Rappel RDV — SMS patient" : "Rappel RDV — in-app (sans téléphone)",
    body: `${input.patientName} · ${appointmentAt} · ${input.serviceUnit}`,
    targetRole: "HOSPITOL_STAFF",
    actionUrl: routes.appointments,
    eventType: "appointment.reminder.sent",
  });

  void notifyAppointmentReminderApi({
    appointmentId: input.appointmentId,
    patientId: input.patientId,
    patientName: input.patientName,
    appointmentAt,
    recipientPhone: phone || undefined,
    serviceUnit: input.serviceUnit,
    practitioner: input.practitioner,
    motif: input.motif,
    tenantId: loadStoredSession()?.tenant?.slug,
  });

  markAppointmentReminderSent(input.appointmentId);

  return {
    channel,
    detail:
      channel === "sms"
        ? `SMS envoyé au ${phone}`
        : "Pas de téléphone patient — rappel in-app simulé",
  };
}
